/**
 * Root App component — providers and router.
 */

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NostrLoginProvider } from "@nostrify/react/login";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppProvider } from "@/components/AppProvider";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { NostrProvider } from "@/components/NostrProvider";
import AppRouter from "./AppRouter";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 60000,
      gcTime: Infinity,
    },
  },
});

export function App() {
  return (
    <ErrorBoundary>
      <AppProvider storageKey="onegroup:config">
        <QueryClientProvider client={queryClient}>
          <NostrLoginProvider storageKey="onegroup:login">
            <NostrProvider>
              <TooltipProvider>
                <AppRouter />
              </TooltipProvider>
            </NostrProvider>
          </NostrLoginProvider>
        </QueryClientProvider>
      </AppProvider>
    </ErrorBoundary>
  );
}

export default App;